import { useElementSize } from '@ui-components/neo.tax';

import { Breakpoints } from '@neo.tax/shared/utils';

export const useIsMobile = (): { isMobile: boolean } => {
  const [_, { width }] = useElementSize();

  // TODO: use md when replacing default screen from optimizer
  // https://linear.app/neo-tax/issue/NEO-2816/create-product-homepage-and-move-optimizer-into-trouser
  return { isMobile: !!width && Breakpoints.LG > width };
};
